import { useEffect, useRef, useState } from "react";
import { media } from "@/lib/format";

export const Spinner = ({ frames, alt, onSpin }) => {
  const [i, setI] = useState(0);
  const start = useRef(null);
  useEffect(() => {
    frames.forEach((f) => { const img = new Image(); img.src = media(f); });
  }, [frames]);
  const down = (e) => { start.current = { x: e.clientX, i }; e.currentTarget.setPointerCapture(e.pointerId); onSpin?.(); };
  const move = (e) => {
    if (!start.current) return;
    const step = Math.round((start.current.x - e.clientX) / 12);
    setI(((start.current.i + step) % frames.length + frames.length) % frames.length);
  };
  const up = () => { start.current = null; };
  return (
    <img src={media(frames[i])} alt={alt} draggable={false} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up}
      className="product-shadow relative max-h-[340px] w-full cursor-grab touch-none object-contain active:cursor-grabbing" data-testid="spin-image" />
  );
};
